import actions from './actions'

const initialState = {
  partner: {
    id: '',
    clover: '',
  },
  images: {
    clover: '',
  },
  redirect_url: '',
  google_account: {
    loading: false,
    data: null,
  },
  loading: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_GOOGLE_ACCOUNT_STATE:
      return { ...state, google_account: { ...state.google_account, ...action.payload } }
    default:
      return state
  }
}
